import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onUploadClick }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-12 text-center">
      <div className="max-w-md mx-auto">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-muted flex items-center justify-center">
          <Icon name="Theater" size={40} className="text-muted-foreground" />
        </div>
        
        <h3 className="text-xl font-semibold text-card-foreground mb-2">
          No Plays Available
        </h3>
        <p className="text-sm text-muted-foreground mb-6">
          Get started by uploading your first Shakespeare play. Upload a CSV file following the specified schema format to begin content management.
        </p>

        <Button
          variant="default"
          onClick={onUploadClick}
          iconName="Upload"
          iconPosition="left"
        >
          Upload Your First Play
        </Button>

        <div className="mt-8 p-4 bg-muted rounded-lg text-left">
          <p className="text-sm font-medium text-card-foreground mb-2">Quick Start Guide:</p>
          <ol className="text-sm text-muted-foreground space-y-2 list-decimal list-inside">
            <li>Prepare your CSV file using the schema format</li>
            <li>Upload the file using the drag-and-drop area</li>
            <li>System will auto-generate unique line IDs</li>
            <li>Review and manage content after processing</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;